(function () {
  const SECTION_ID = 'hanro-wishlist-data';
  const CART_ICON_SVG =
    '<svg class="hanro-wishlist__cart-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.3" d="M16.608 9.421V6.906H3.392v8.016c0 .567.224 1.112.624 1.513.4.402.941.627 1.506.627H8.63M8.818 3h2.333c.618 0 1.212.247 1.649.686a2.35 2.35 0 0 1 .683 1.658v1.562H6.486V5.344c0-.622.246-1.218.683-1.658A2.33 2.33 0 0 1 8.82 3"/><path stroke="currentColor" stroke-linecap="round" stroke-width="1.3" d="M14.608 12.563v5m2.5-2.5h-5"/></svg>';

  const metafieldCache = new Map();
  const pendingFetches = new Map();
  let srStatus = null;

  function extractHandle(item) {
    const link =
      item.querySelector('.swym-wishlist-image-wrapper a[href]') ||
      item.querySelector('.swym-wishlist-image-wrapper[href]') ||
      item.querySelector('a[href*="/products/"]');
    if (!link) return null;
    const match = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  }

  async function fetchMetafields(handle) {
    if (metafieldCache.has(handle)) return metafieldCache.get(handle);
    if (pendingFetches.has(handle)) return pendingFetches.get(handle);

    const promise = (async () => {
      try {
        const res = await fetch(
          `/products/${handle}?sections=${SECTION_ID}`,
          { credentials: 'same-origin' }
        );
        if (!res.ok) {
          console.warn(`[hanro-wishlist] Product fetch failed for "${handle}": ${res.status}`);
          metafieldCache.set(handle, null);
          return null;
        }
        const json = await res.json();
        const html = json[SECTION_ID];
        if (!html) {
          metafieldCache.set(handle, null);
          return null;
        }
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const script = doc.querySelector('[data-hanro-wishlist-data]');
        if (!script) {
          metafieldCache.set(handle, null);
          return null;
        }
        const data = JSON.parse(script.textContent);
        metafieldCache.set(handle, data);
        return data;
      } catch (err) {
        console.warn(`[hanro-wishlist] Error fetching metafields for "${handle}":`, err);
        metafieldCache.set(handle, null);
        return null;
      } finally {
        pendingFetches.delete(handle);
      }
    })();

    pendingFetches.set(handle, promise);
    return promise;
  }

  function injectCollectionLabel(item, collectionName) {
    if (!collectionName) return;
    if (item.querySelector('.hanro-wishlist__collection')) return;
    const label = document.createElement('div');
    label.className = 'hanro-wishlist__collection';
    label.textContent = collectionName;
    const title = item.querySelector('.swym-title');
    if (title) {
      title.parentNode.insertBefore(label, title);
    }
  }

  function cleanBtnTextNodes(btn) {
    btn.childNodes.forEach(function (node) {
      if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
        node.remove();
      }
    });
  }

  function getCardVariantId(item) {
    var link = item.querySelector('a[href*="variant"]');
    if (!link) return null;
    try {
      var url = new URL(link.href, window.location.origin);
      return url.searchParams.get('variant');
    } catch (e) {
      return null;
    }
  }

  function setupAtcButton(item) {
    const btn = item.querySelector('.swym-add-to-cart-btn');
    if (!btn) return;

    if (!btn.querySelector('.hanro-wishlist__cart-icon')) {
      var label = btn.textContent.trim();
      btn.innerHTML = CART_ICON_SVG + '<span>' + label + '</span>';
    }
    cleanBtnTextNodes(btn);

    var btnObserver = new MutationObserver(function () {
      cleanBtnTextNodes(btn);
    });
    btnObserver.observe(btn, { childList: true });

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (btn.classList.contains('hanro-wishlist__atc--added')) return;

      var variantId = getCardVariantId(item);
      if (!variantId) return;

      var textSpan = btn.querySelector('span:not(.hanro-wishlist__cart-icon)');
      var originalText = textSpan ? textSpan.textContent : '';
      if (textSpan) textSpan.textContent = 'Adding...';

      addToShopifyCart(variantId, 1).then(function (result) {
        if (result.error) {
          if (textSpan) textSpan.textContent = originalText;
          return;
        }
        btn.classList.add('hanro-wishlist__atc--added');
        btn.disabled = true;
        if (textSpan) textSpan.textContent = 'Added to Cart';
        announce('Added to Cart');
      }).catch(function () {
        if (textSpan) textSpan.textContent = originalText;
      });
    }, true);
  }

  function getDetailVariantId(container) {
    var detailInfo = container.closest('.swym-wishlist-product-detail-info') ||
      container.closest('.swym-wishlist-product-detail-content');
    if (!detailInfo) return null;
    var link = detailInfo.querySelector('a[href*="variant"]');
    if (!link) return null;
    try {
      return new URL(link.href).searchParams.get('variant');
    } catch (e) {
      return null;
    }
  }

  var ERROR_ICON_SVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="7.5" stroke="currentColor"/><path d="M8 4v5" stroke="currentColor" stroke-linecap="round"/><circle cx="8" cy="11.5" r="0.75" fill="currentColor"/></svg>';

  function getCartSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      if (el.dataset.sectionId) ids.push(el.dataset.sectionId);
    });
    return ids;
  }

  function addToShopifyCart(variantId, quantity) {
    var sectionIds = getCartSectionIds();
    var body = {
      items: [{ id: parseInt(variantId, 10), quantity: quantity }]
    };
    if (sectionIds.length) body.sections = sectionIds.join(',');

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { status: res.status, data: data };
        });
      })
      .then(function (result) {
        var isPartial = result.status === 422;
        var isError = result.data.status && !isPartial;
        var errorMessage = isPartial ? result.data.message || result.data.description : null;

        if (isError) {
          return { error: true, message: result.data.message || result.data.description || 'Could not add to cart' };
        }

        var sections = result.data.sections || {};
        return fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var event = new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cart,
                data: {
                  source: 'hanro-wishlist',
                  itemCount: cart.item_count,
                  sections: sections
                }
              }
            });
            document.dispatchEvent(event);
            if (isPartial) {
              return { error: true, message: errorMessage };
            }
            return { error: false };
          });
      });
  }

  function showAtcError(container, message) {
    var errorEl = container.parentElement.querySelector('.hanro-wishlist__atc-error');
    if (!errorEl) {
      errorEl = document.createElement('div');
      errorEl.className = 'hanro-wishlist__atc-error';
      container.parentElement.insertBefore(errorEl, container.nextSibling);
    }
    errorEl.innerHTML = ERROR_ICON_SVG + '<span>' + message + '</span>';
    errorEl.classList.remove('hidden');
    setTimeout(function () {
      errorEl.classList.add('hidden');
    }, 10000);
  }

  function getDetailQty(container) {
    var input = container.querySelector('.hanro-wishlist__qty-value');
    return input ? (parseInt(input.value, 10) || 1) : 1;
  }

  function enhanceDetailAtc(root) {
    var containers = root.querySelectorAll('.swym-action-button-container');
    containers.forEach(function (container) {
      // Swym re-renders this container on every variant change, appending extra
      // native buttons and re-injecting stray "Add To Cart" text nodes. Reconcile
      // to a single styled button + one qty selector on each pass (idempotent).
      var btns = container.querySelectorAll('.swym-wishlist-add-to-cart-btn');
      if (!btns.length) return;

      // Keep only the first add-to-cart button; remove Swym's duplicates.
      for (var i = btns.length - 1; i >= 1; i--) {
        btns[i].parentNode.removeChild(btns[i]);
      }
      var btn = btns[0];

      // Ensure icon + span, then strip any stray text nodes Swym re-injects.
      if (!btn.querySelector('.hanro-wishlist__cart-icon')) {
        btn.innerHTML = CART_ICON_SVG + '<span>' + btn.textContent.trim() + '</span>';
      }
      cleanBtnTextNodes(btn);
      if (!btn.hasAttribute('data-hanro-clean-observed')) {
        btn.setAttribute('data-hanro-clean-observed', '');
        var btnObserver = new MutationObserver(function () {
          cleanBtnTextNodes(btn);
        });
        btnObserver.observe(btn, { childList: true });
      }

      // Ensure exactly one qty selector, positioned before the button.
      var qtys = container.querySelectorAll('.hanro-wishlist__qty');
      for (var j = qtys.length - 1; j >= 1; j--) {
        qtys[j].parentNode.removeChild(qtys[j]);
      }
      var qty = qtys[0];
      if (!qty) {
        qty = document.createElement('div');
        qty.className = 'hanro-wishlist__qty';
        qty.innerHTML =
          '<button type="button" class="hanro-wishlist__qty-btn" data-action="minus" aria-label="Decrease quantity">&minus;</button>' +
          '<input type="number" class="hanro-wishlist__qty-value" value="1" min="1" max="99" aria-label="Quantity">' +
          '<button type="button" class="hanro-wishlist__qty-btn" data-action="plus" aria-label="Increase quantity">+</button>';
        var input = qty.querySelector('.hanro-wishlist__qty-value');
        qty.addEventListener('click', function (e) {
          var action = e.target.getAttribute('data-action');
          if (!action) return;
          var val = parseInt(input.value, 10) || 1;
          if (action === 'minus' && val > 1) input.value = val - 1;
          if (action === 'plus' && val < 99) input.value = val + 1;
        });
      }
      if (btn.previousElementSibling !== qty) {
        container.insertBefore(qty, btn);
      }
    });
  }

  // One delegated, capture-phase handler so add-to-cart survives Swym re-renders
  // without re-wiring per button. Suppresses Swym's native handler to avoid a
  // double add.
  function handleDetailAtcClick(e) {
    var btn = e.target.closest('.swym-wishlist-add-to-cart-btn');
    if (!btn) return;
    var container = btn.closest('.swym-action-button-container');
    if (!container) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    if (btn.disabled) return;

    var variantId = getDetailVariantId(container);
    if (!variantId) return;
    var quantity = getDetailQty(container);
    var textSpan = btn.querySelector('span');
    var originalText = textSpan ? textSpan.textContent : '';
    if (textSpan) textSpan.textContent = 'Adding...';

    addToShopifyCart(variantId, quantity).then(function (result) {
      if (result.error) {
        if (textSpan) textSpan.textContent = originalText;
        showAtcError(container, result.message);
        return;
      }
      btn.disabled = true;
      if (textSpan) textSpan.textContent = 'Added to Cart';
      announce('Added to Cart');
    }).catch(function () {
      if (textSpan) textSpan.textContent = originalText;
      showAtcError(container, 'Something went wrong. Please try again.');
    });
  }

  function convertVariantSelects(root) {
    var selects = root.querySelectorAll('.swym-wishlist-variant-select select');
    selects.forEach(function (select) {
      if (select.hasAttribute('data-hanro-buttons')) return;
      select.setAttribute('data-hanro-buttons', '');

      var label = select.closest('.swym-wishlist-variant-select').querySelector('.swym-label');

      if (label && !label.hasAttribute('data-hanro-label-base')) {
        label.setAttribute('data-hanro-label-base', (label.textContent.split(':')[0] || '').trim());
      }

      function selectedText() {
        var opt = select.options[select.selectedIndex];
        return opt ? opt.text : select.value;
      }

      function normalizeLabel() {
        if (!label) return;
        var base = label.getAttribute('data-hanro-label-base') || '';
        var next = base + ': ' + selectedText();
        if (label.textContent !== next) label.textContent = next;
      }
      normalizeLabel();

      if (label && !label.hasAttribute('data-hanro-label-observed')) {
        label.setAttribute('data-hanro-label-observed', '');
        var labelObserver = new MutationObserver(function () {
          normalizeLabel();
        });
        labelObserver.observe(label, { childList: true, characterData: true, subtree: true });
      }

      var wrapper = document.createElement('div');
      wrapper.className = 'hanro-wishlist__variant-buttons';

      for (var i = 0; i < select.options.length; i++) {
        var opt = select.options[i];
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'hanro-wishlist__variant-btn';
        btn.textContent = opt.text;
        btn.setAttribute('data-value', opt.value);
        btn.setAttribute('aria-pressed', opt.value === select.value ? 'true' : 'false');

        btn.addEventListener('click', (function (value) {
          return function () {
            select.value = value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
            wrapper.querySelectorAll('.hanro-wishlist__variant-btn').forEach(function (b) {
              b.setAttribute('aria-pressed', b.getAttribute('data-value') === value ? 'true' : 'false');
            });
            normalizeLabel();
          };
        })(opt.value));

        wrapper.appendChild(btn);
      }

      var swymSelect = select.closest('.swym-select');
      if (swymSelect) {
        swymSelect.style.display = 'none';
        swymSelect.parentNode.appendChild(wrapper);
      }
    });
  }

  function announce(message) {
    if (!srStatus) return;
    srStatus.textContent = '';
    requestAnimationFrame(() => {
      srStatus.textContent = message;
    });
  }

  async function enhanceItem(item) {
    if (item.hasAttribute('data-hanro-enhanced')) return;
    item.setAttribute('data-hanro-enhanced', '');

    const handle = extractHandle(item);
    if (!handle) {
      console.warn('[hanro-wishlist] Could not extract product handle from item', item);
      setupAtcButton(item);
      return;
    }

    const data = await fetchMetafields(handle);
    if (data && data.collection_name) {
      injectCollectionLabel(item, data.collection_name);
    }
    if (data && data.style_name) {
      var title = item.querySelector('.swym-title');
      if (title) {
        title.textContent = data.style_name;
        var titleObserver = new MutationObserver(function () {
          if (title.textContent !== data.style_name) {
            title.textContent = data.style_name;
          }
        });
        titleObserver.observe(title, { childList: true, characterData: true, subtree: true });
      }
    }
    setupAtcButton(item);
  }

  function enhanceAll(root) {
    const items = root.querySelectorAll(
      '.swym-wishlist-item:not([data-hanro-enhanced])'
    );
    if (items.length === 0) return;
    items.forEach((item) => enhanceItem(item));
  }

  function init() {
    const container = document.getElementById('swym-wishlist-render-container');
    if (!container) return;

    srStatus = document.createElement('div');
    srStatus.className = 'hanro-wishlist__sr-status';
    srStatus.setAttribute('aria-live', 'polite');
    srStatus.setAttribute('role', 'status');
    container.closest('.hanro-wishlist').appendChild(srStatus);

    container.addEventListener('click', handleDetailAtcClick, true);

    enhanceAll(container);
    convertVariantSelects(container);
    enhanceDetailAtc(container);

    var loader = document.getElementById('hanro-wishlist-loader');

    function revealContainer() {
      if (loader) loader.classList.add('hanro-hidden');
      container.style.transition = 'opacity 0.3s ease';
      container.style.opacity = '1';
    }

    setTimeout(revealContainer, 4000);

    const observer = new MutationObserver((mutations) => {
      let needsEnhance = false;
      for (const mutation of mutations) {
        if (mutation.addedNodes.length > 0) {
          needsEnhance = true;
          break;
        }
      }
      if (needsEnhance) {
        enhanceAll(container);
        convertVariantSelects(container);
        enhanceDetailAtc(container);
      }
    });

    observer.observe(container, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
